module.exports = __webpack_public_path__ + "img/29.545b8d63.jpg";